module.exports = __webpack_public_path__ + "media/1alB-p-Laxup.47e1b84b.mp3";